<template>
  <div v-if="hide"></div>
  <NumeraiLoader v-else-if="loading" />
  <div v-else>
    <div v-if="outerSeasonToggle" class="flexrow space_between mb-3 mt-3">
      <div>
        <p
          v-if="showPrevSeason"
          class="season-nav-link d-flex align_center mb-0"
          @click="() => changeSeason(-1)"
        >
          <v-icon small>mdi-chevron-double-left</v-icon> View
          {{ prevYear }} status
        </p>
      </div>
      <div>
        <p
          v-if="showNextSeason"
          class="season-nav-link d-flex align_center mb-0"
          @click="() => changeSeason(1)"
        >
          View {{ nextYear }} status
          <v-icon small>mdi-chevron-double-right</v-icon>
        </p>
      </div>
    </div>
    <NumeraiPaper v-if="!isLoggedIn" class="pt-5 pb-10 px-10">
      <div class="season-title">{{ seasonTitle }}</div>
      <div class="flexrow">
        <div class="logged-out-season-stat">
          <div class="season-stat-label">Status</div>
          <div
            class="season-stat-value"
            :class="{ 'null-number': !seasonStatus }"
          >
            {{ seasonStatus }}
          </div>
          <div class="season-stat-sublabel">
            {{ roundsLeftSubtitle }}
          </div>
        </div>
        <div v-if="seasonStatus == 'Open'" class="logged-out-season-stat">
          <div class="season-stat-label">Scoring starts</div>
          <div class="season-stat-value">
            {{ firstScoreDate }}
          </div>
        </div>
        <div class="logged-out-season-stat">
          <div class="season-stat-label">Participants</div>
          <div
            class="season-stat-value"
            :class="{
              'null-number': selectedSeason && !selectedSeason.participants,
            }"
          >
            {{
              selectedSeason && selectedSeason.participants
                ? selectedSeason.participants
                : ''
            }}
          </div>
        </div>
      </div>
      <div v-if="!outerSeasonToggle" class="flexrow space_between mt-3">
        <div>
          <p
            v-if="showPrevSeason"
            class="season-nav-link d-flex align_center mb-0"
            @click="() => changeSeason(-1)"
          >
            <v-icon small>mdi-chevron-double-left</v-icon>View
            {{ prevYear }} status
          </p>
        </div>
        <div>
          <p
            v-if="showNextSeason"
            class="season-nav-link d-flex align_center mb-0"
            @click="() => changeSeason(1)"
          >
            View {{ nextYear }} status
            <v-icon small>mdi-chevron-double-right</v-icon>
          </p>
        </div>
      </div>
    </NumeraiPaper>
    <NumeraiPaper
      v-else-if="view === 'qualifying'"
      class="qualifying-banner-container"
    >
      <div class="qualifying-banner">
        <div class="gm-qualifying"></div>
        <div class="pa-10 full-width">
          <div class="flexrow space_between mb-6">
            <div>
              <div class="season-title">{{ seasonTitle }}</div>
              <div class="season-subtitle">{{ seasonSubtitle }}</div>
            </div>
            <ProgressRing
              :progress-percent="progressPercent"
              :numerator="progressNumerator"
              :denominator="progressDenominator"
            ></ProgressRing>
          </div>
          <template v-for="(requirement, index) in qualifyingRequirements">
            <div :key="index" class="flexrow align_start mb-4">
              <v-icon
                class="check-icon mr-3"
                :color="
                  requirement.completed ? '#71E200' : 'var(--color-grey10)'
                "
                >{{
                  requirement.completed ? 'mdi-check-circle' : 'mdi-circle'
                }}</v-icon
              >
              <div>
                <div
                  :class="{
                    complete: requirement.completed,
                    dark: isDarkMode,
                  }"
                >
                  <div class="requirement-title">{{ requirement.title }}</div>
                </div>
                <p :class="{ complete: requirement.completed }">
                  {{ requirement.description }}
                </p>
                <p class="progress-description">
                  {{ requirement.progressDescription }}
                </p>
              </div>
            </div>
          </template>
          <div v-if="!outerSeasonToggle" class="flexrow space_between mt-3">
            <div>
              <p
                v-if="showPrevSeason"
                class="season-nav-link d-flex align_center mb-0"
                @click="() => changeSeason(-1)"
              >
                <v-icon small>mdi-chevron-double-left</v-icon>View
                {{ prevYear }} status
              </p>
            </div>
            <div>
              <p
                v-if="showNextSeason"
                class="season-nav-link d-flex align_center mb-0"
                @click="() => changeSeason(1)"
              >
                View {{ nextYear }} status
                <v-icon small>mdi-chevron-double-right</v-icon>
              </p>
            </div>
          </div>
        </div>
      </div>
    </NumeraiPaper>
    <NumeraiPaper v-else-if="view === 'unqualified'" class="py-5 px-10">
      <div class="flexrow align_center">
        <div class="unqualified-info">
          <div class="season-title">{{ seasonTitle }}</div>
          <p>
            It is too late to qualify for season
            {{ selectedSeason && selectedSeason.year }}. You can join Season
            {{ selectedSeason && selectedSeason.year + 1 }}
            on January 2nd. You may still participate in the tournament, however
            you will not receive a season title.
          </p>
        </div>
        <div
          v-if="selectedSeason.daysUntilNextSeasonOpen >= 0"
          class="days-until-open text-center"
        >
          <div class="season-stat-value">
            {{ selectedSeason && selectedSeason.daysUntilNextSeasonOpen }}
          </div>
          <div class="season-stat-sublabel">Days until open</div>
        </div>
      </div>
      <div v-if="!outerSeasonToggle" class="flexrow space_between mt-3">
        <div>
          <p
            v-if="showPrevSeason"
            class="season-nav-link d-flex align_center mb-0"
            @click="() => changeSeason(-1)"
          >
            <v-icon small>mdi-chevron-double-left</v-icon>View
            {{ prevYear }} status
          </p>
        </div>
        <div>
          <p
            v-if="showNextSeason"
            class="season-nav-link d-flex align_center mb-0"
            @click="() => changeSeason(1)"
          >
            View {{ nextYear }} status<v-icon small
              >mdi-chevron-double-right</v-icon
            >
          </p>
        </div>
      </div>
    </NumeraiPaper>
    <NumeraiPaper
      v-else-if="view === 'showTier'"
      class="py-5 px-10 pl-5 show-tier-container"
    >
      <div class="banner-container">
        <div class="profile-pic-container showTier">
          <div
            class="profile-pic-banner"
            :class="{
              default: !profilePicUrl,
            }"
            :style="
              profilePicUrl
                ? { backgroundImage: `url('${profilePicUrl}')` }
                : null
            "
          ></div>
          <div class="gm-title" :class="{ [title]: title }">
            {{ title }}
          </div>
        </div>
        <div class="full-width">
          <div class="flexrow align_center">
            <div class="season-title">{{ seasonTitle }}</div>
            <div v-if="firstAvailableScore" class="first-score">
              {{ firstAvailableScore }}
            </div>
          </div>
          <div class="show-tier-content">
            <div v-if="selectedSeason.year <= 2023" class="season-stat">
              <div class="season-stat-label">TC Rank</div>
              <div
                class="season-stat-value"
                :class="{
                  'null-number': !seasonTcRank,
                }"
              >
                {{ seasonTcRank && seasonTcRank.toLocaleString() }}
              </div>
              <div class="season-stat-sublabel">
                of
                {{
                  selectedSeason &&
                    selectedSeason.participants &&
                    selectedSeason.participants.toLocaleString()
                }}
              </div>
            </div>
            <div v-if="selectedSeason.year <= 2023" class="season-stat">
              <div class="season-stat-label">
                {{
                  {
                    8: 'CORR Rank',
                    11: 'FNC Rank',
                  }[getTournamentNumber()]
                }}
              </div>
              <div
                class="season-stat-value"
                :class="{
                  'null-number': !seasonCorrRank,
                }"
              >
                {{ seasonCorrRank && seasonCorrRank.toLocaleString() }}
              </div>
              <div class="season-stat-sublabel">
                of
                {{
                  selectedSeason &&
                    selectedSeason.participants &&
                    selectedSeason.participants.toLocaleString()
                }}
              </div>
            </div>
            <div v-if="selectedSeason.year > 2023" class="season-stat">
              <div class="season-stat-label">Season Rank</div>
              <div
                class="season-stat-value"
                :class="{
                  'null-number': !seasonScoreRank,
                }"
              >
                {{ seasonScoreRank && seasonScoreRank.toLocaleString() }}
              </div>
              <div class="season-stat-sublabel">
                of
                {{
                  selectedSeason &&
                    selectedSeason.participants &&
                    selectedSeason.participants.toLocaleString()
                }}
              </div>
            </div>
            <div class="season-stat">
              <div class="season-stat-label">{{ tierHeader }}</div>
              <div
                class="season-stat-value"
                :class="{ 'null-number': !provisionalTier }"
              >
                {{ provisionalTier }}
              </div>
              <div v-if="provisionalTierSubtitle" class="season-stat-sublabel">
                {{ provisionalTierSubtitle }}
              </div>
            </div>
            <div>
              <div class="season-stat-label">{{ seasonStatusLabel }}</div>
              <div class="season-stat-value">
                {{ seasonStatusValue }}
              </div>
              <div class="season-stat-sublabel">
                {{ roundsLeftSubtitle }}
              </div>
            </div>
          </div>
          <div v-if="!outerSeasonToggle" class="flexrow space_between mt-3">
            <div>
              <p
                v-if="showPrevSeason"
                class="season-nav-link d-flex align_center mb-0"
                @click="() => changeSeason(-1)"
              >
                <v-icon small>mdi-chevron-double-left</v-icon> View
                {{ prevYear }} status
              </p>
            </div>
            <div>
              <p
                v-if="showNextSeason"
                class="season-nav-link d-flex align_center mb-0"
                @click="() => changeSeason(1)"
              >
                View {{ nextYear }} status
                <v-icon small>mdi-chevron-double-right</v-icon>
              </p>
            </div>
          </div>
        </div>
      </div>
    </NumeraiPaper>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { NumeraiPaper, ProgressRing, NumeraiLoader } from '@/components/shared'
import { getDefaultSeasonIndex, getTournamentNumber } from '@/lib/utils'
import moment from 'moment'

export default {
  components: {
    NumeraiPaper,
    ProgressRing,
    NumeraiLoader,
  },
  props: {
    outerSeasonToggle: { type: Boolean, default: false },
    onSeasonChange: { type: Function, default: () => {} },
    doneLoading: { type: Function, default: () => {} },
    hide: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      selectedSeasonIndex: 0,
      seasonStatuses: [],
    }
  },
  computed: {
    ...mapState(['accountInfo']),
    ...mapGetters(['isLoggedIn', 'isDarkMode']),
    title() {
      return (
        (this.selectedSeason &&
          this.selectedSeason.titleInfo &&
          this.selectedSeason.titleInfo.title) ||
        'Novice'
      )
    },
    view() {
      if (
        this.selectedSeason &&
        (this.selectedSeason.status === 'open' ||
          this.selectedSeason.status === 'closed') &&
        20 - this.selectedSeason.numQualifyingSubmissions >
          this.selectedSeason.roundsLeft
      ) {
        return 'unqualified'
      }
      if (
        this.selectedSeason &&
        this.selectedSeason.status === 'open' &&
        this.selectedSeason.numQualifyingSubmissions < 20
      ) {
        return 'qualifying'
      }
      return 'showTier'
    },
    showPrevSeason() {
      return (
        this.seasonStatuses.length &&
        this.selectedSeasonIndex !== -1 &&
        this.seasonStatuses.length - this.selectedSeasonIndex <
          this.seasonStatuses.length
      )
    },
    showNextSeason() {
      return (
        this.seasonStatuses.length &&
        this.selectedSeasonIndex !== -1 &&
        this.seasonStatuses.length - this.selectedSeasonIndex > 1
      )
    },
    selectedSeason() {
      return this.seasonStatuses[this.selectedSeasonIndex]
    },
    prevYear() {
      return this.seasonStatuses[this.selectedSeasonIndex - 1].year
    },
    nextYear() {
      return this.seasonStatuses[this.selectedSeasonIndex + 1].year
    },
    profilePicUrl() {
      return this.accountInfo && this.accountInfo.profileUrl
    },
    seasonTitle() {
      if (!this.selectedSeason) {
        return null
      }
      let context = ''
      if (this.isLoggedIn) {
        context = 'Your'
      }

      if (this.view === 'showTier' && this.selectedSeason.status === 'open') {
        context = 'Provisional'
      }
      return `${context} Season ${this.selectedSeason.year} Status`
    },
    seasonTcRank() {
      if (
        !this.selectedSeason ||
        !this.selectedSeason.seasonAccountPerformance
      ) {
        return null
      }
      let res = null
      for (const data of this.selectedSeason.seasonAccountPerformance) {
        if (data.scoreName == 'canon_tc') {
          res = data.rank
        }
      }
      return res
    },
    seasonCorrRank() {
      if (
        !this.selectedSeason ||
        !this.selectedSeason.seasonAccountPerformance
      ) {
        return null
      }
      let res = null
      for (const data of this.selectedSeason.seasonAccountPerformance) {
        if (data.scoreName == 'canon_corr') {
          res = data.rank
        }
      }
      return res
    },
    seasonScoreRank() {
      if (
        !this.selectedSeason ||
        !this.selectedSeason.seasonAccountPerformance
      ) {
        return null
      }
      let res = null
      for (const data of this.selectedSeason.seasonAccountPerformance) {
        if (data.scoreName == 'season_score') {
          res = data.rank
        }
      }
      return res
    },
    seasonStatus() {
      if (!this.selectedSeason) {
        return null
      }
      return `${this.selectedSeason.status[0].toUpperCase()}${this.selectedSeason.status.slice(
        1,
        this.selectedSeason.length,
      )}`
    },
    seasonStatusValue() {
      if (!this.selectedSeason) {
        return null
      }
      switch (this.selectedSeason.status) {
        case 'open':
          return this.selectedSeason.roundsLeft
        case 'closed':
          return 'Closed'
        case 'resolved':
          return 'Resolved'
        case 'resolving':
          return 'Closed'
        default:
          return null
      }
    },
    tierHeader() {
      if (!this.selectedSeason) {
        return null
      }
      if (this.selectedSeason.status === 'resolved') {
        return 'Final Tier'
      }
      return 'Provisional Tier'
    },
    provisionalTier() {
      if (!this.selectedSeason || !this.selectedSeason.titleInfo) {
        return null
      }
      return this.selectedSeason.titleInfo.title
    },
    provisionalTierSubtitle() {
      if (this.provisionalTier === 'Novice') {
        return null
      }
      if (!this.selectedSeason || !this.selectedSeason.titleInfo) {
        return null
      }
      return this.selectedSeason.titleInfo.titleDescription
    },
    seasonStatusLabel() {
      if (!this.selectedSeason) {
        return null
      }
      return this.selectedSeason.status === 'resolved' ||
        this.selectedSeason.status === 'resolving' ||
        this.selectedSeason.status === 'closed'
        ? 'Status'
        : 'Rounds Left'
    },
    roundsLeftSubtitle() {
      if (!this.selectedSeason) {
        return null
      }

      const isOpen = this.selectedSeason.status === 'open'
      const isClosed = this.selectedSeason.status === 'closed'
      const isResolved = this.selectedSeason.status === 'resolved'
      // if season is open, show "Closes on <date>"
      // if season is closed, show "Resolving on <date>"
      // if season is resolved, show "Resolved on <date>"
      if (isOpen) {
        return `Closes on ${moment(this.selectedSeason.closeStakingEnd).format(
          'MMM Do YYYY',
        )}`
      } else if (isClosed) {
        return `Resolving on ${moment(this.selectedSeason.resolveDate).format(
          'MMM Do YYYY',
        )}`
      } else {
        return `${isResolved ? 'Resolved' : 'Resolving'} on ${moment(
          this.selectedSeason.resolveDate,
        ).format('MMM Do YYYY')}`
      }
    },
    firstScoreDate() {
      if (!this.selectedSeason) {
        return null
      }
      return moment(this.selectedSeason.firstScoreDate).format('MMM Do YYYY')
    },
    seasonSubtitle() {
      if (!this.selectedSeason) {
        return null
      }
      return `Make 20 staked submissions by ${moment(
        this.selectedSeason.closeStakingEnd,
      ).format('MMM Do YYYY')} to qualify for the season.`
    },
    progressPercent() {
      if (!this.selectedSeason) {
        return null
      }
      return `${(this.progressNumerator / this.progressDenominator) * 100}%`
    },
    progressNumerator() {
      if (!this.selectedSeason) {
        return null
      }
      let counter = 0
      if (this.selectedSeason.hasStakedOneNmr) {
        counter += 1
      }
      counter += this.selectedSeason.numQualifyingSubmissions
      return counter
    },
    progressDenominator() {
      return 21
    },
    qualifyingRequirements() {
      return [
        {
          title: 'Stake 1 NMR',
          description: 'Stake a total of at least 1 NMR on your models',
          progressDescription: '',
          completed: this.selectedSeason.hasStakedOneNmr,
        },
        {
          title: '20 Staked Submissions >= 1 NMR',
          description:
            'Make 20 submissions in distinct rounds with at least 1 NMR staked across your models.',
          progressDescription:
            'Your current number of qualified staked submissions: ' +
            this.selectedSeason.numQualifyingSubmissions,
          completed: this.selectedSeason.numQualifyingSubmissions >= 20,
        },
      ]
    },
    firstAvailableScore() {
      if (!this.selectedSeason) {
        return null
      }
      if (
        this.selectedSeason.status === 'open' &&
        !this.selectedSeason.hasScores
      ) {
        return `Your first scores will be available ${moment(
          this.selectedSeason.firstScoreDate,
        ).format('MMM Do YYYY')}`
      }

      return null
    },
  },
  async created() {
    await this.fetchSeasonStatuses()
    this.selectedSeasonIndex = getDefaultSeasonIndex(this.seasonStatuses)
  },
  methods: {
    getTournamentNumber,
    async fetchSeasonStatuses() {
      this.loading = true
      this.seasonStatuses = await this.$client.getSeasonAccountSummary(
        getTournamentNumber(),
      )
      this.loading = false
      this.doneLoading()
    },
    changeSeason(incrementIndex) {
      this.selectedSeasonIndex += incrementIndex
      this.selectedSeason &&
        this.selectedSeason.year &&
        this.onSeasonChange(this.selectedSeason.year)
    },
  },
}
</script>
<style lang="scss">
.season-nav-link {
  &:hover {
    cursor: pointer;
  }
}

.season-title {
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 15px;
}

.first-score {
  margin-bottom: 10px;
  margin-left: 20px;
  font-size: 14px;
  font-weight: 600;
  color: var(--color-grey50);
}

.season-subtitle {
  font-size: 16px;
  line-height: 1.5;
}

.gm-qualifying {
  flex-shrink: 0;
  background-image: url('~@/assets/gm_qualifying.png');
  width: 100%;
  height: 400px;
  background-size: contain;
  background-position: center;
  background-color: #000000;
}

.requirement-title {
  font-size: 20px;
  text-decoration: underline;
  line-height: 1;
  margin-bottom: 8px;
}

.qualifying-banner-container {
  container-type: inline-size;
  container-name: qualifying;
  position: relative;
}

.progress-description {
  color: #ffb800;
  font-weight: 600;
}

@container qualifying (min-width: 838px) {
  .qualifying-banner {
    display: flex;
    flex-direction: row;
  }

  .gm-qualifying {
    width: 360px;
    background-size: cover;
  }
}

.show-tier-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.season-stat {
  margin-bottom: 30px;
}

.show-tier-container {
  container-type: inline-size;
  container-name: tier;
}

.profile-pic-container.showTier {
  margin-bottom: 20px;
}

@container tier (min-width: 815px) {
  .show-tier-content {
    flex-direction: row;
  }

  .season-stat {
    margin-bottom: 0;
  }

  .banner-container {
    display: flex;
    flex-direction: row;
  }

  .profile-pic-container.showTier {
    margin-bottom: 0px;
  }
}

.logged-out-season-stat {
  margin-right: 150px;
}

.season-stat-label {
  font-size: 16px;
  font-weight: 600;
}

.season-stat-value {
  font-size: 40px;
  font-weight: 500;
  line-height: 1.2;
  margin-bottom: 3px;
}

.season-stat-sublabel {
  font-size: 14px;
  color: var(--color-grey50);
}

.profile-pic-banner {
  width: 150px;
  height: 150px;
  background-size: cover;
  background-position: center;
  flex-shrink: 0;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  margin-right: 30px;

  &.default {
    background-image: var(--default_profile_picture);
  }
}

.gm-title {
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  padding: 2px 0;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  width: 150px;
  color: #ffffff;

  &.Grandmaster {
    background-color: var(--color-grandmaster);
    color: #000000;
  }

  &.Master {
    background-color: var(--color-master);
    color: #000000;
  }

  &.Expert {
    background-color: var(--color-expert);
    color: #000000;
  }

  &.Researcher {
    background-color: var(--color-researcher);
  }

  &.Contributor {
    background-color: var(--color-contributor);
  }

  &.Apprentice {
    background-color: var(--color-apprentice);
  }

  &.Novice {
    background-color: var(--color-novice);
  }
}

.gm-rank {
  padding: 4px 10px;
  border-radius: 8px;
  color: #ffffff;

  &.Grandmaster {
    background-color: var(--color-grandmaster);
    color: #000000;
  }

  &.Master {
    background-color: var(--color-master);
    color: #000000;
  }

  &.Expert {
    background-color: var(--color-expert);
    color: #000000;
  }

  &.Researcher {
    background-color: var(--color-researcher);
  }

  &.Contributor {
    background-color: var(--color-contributor);
  }

  &.Apprentice {
    background-color: var(--color-apprentice);
  }

  &.Novice {
    background-color: var(--color-novice);
  }
}

.unqualified-info {
  margin-right: 150px;
}

.days-until-open {
  width: 150px;
}

.title-earned-container {
  position: relative;
}

.dismiss-icon {
  position: absolute;
  top: 8px;
  right: 10px;

  &:hover {
    cursor: pointer;
  }
}
</style>
